import type { ObraListaItem } from "@/modules/obras";
import { condicaoDoBarco, resolverCondicao } from "@/shared/components";
import type { ObraCardProps, ObrasKanbanColumn } from "@/shared/components";

import { OBRAS_NO_VALUE } from "../../obras-lista.constants";
import type { ObrasCardsProps, ObrasCardsViewModel } from "./types-obras-cards";

/** `ObraListaItem` para as props do `ObraCard`; o orçado (o "R$ y" do Realizado) ainda não tem fonte no contrato. */
function obraCardProps(obra: ObraListaItem): ObraCardProps {
  const condicao = resolverCondicao(obra.condicao);

  return {
    codigo: obra.codigo,
    embarcacao: obra.embarcacao.nome,
    condicao: condicaoDoBarco(obra.condicao),
    // Fora do mapa o ícone é o padrão e a tooltip guarda o texto recebido.
    condicaoTooltip: condicao && !condicao.known ? condicao.label : undefined,
    inicio: obra.inicio,
    fim: obra.fim,
    duracaoDias: obra.duracaoDias,
    tipos: obra.tiposObra,
    realizado: obra.realizadoBrlMilhoes,
    orcado: null,
    metricas: {
      empenhado: obra.empenhadoPercentual,
      comprometido: obra.comprometidoPercentual,
      estimado: obra.estimadoPercentual,
      naoComprometido: obra.naoComprometidoPercentual,
    },
    testId: `obra-card-${obra.id}`,
  };
}

export function useObrasCards({
  isLoading = false,
  isMobile = false,
  columns,
  state,
  onLoadMore,
}: ObrasCardsProps): ObrasCardsViewModel {
  const boardColumns = columns.map((column): ObrasKanbanColumn => {
    const data = state[column.code];
    const success = data?.status === "success";

    return {
      code: column.code,
      label: column.label,
      testId: `obras-column-${column.code}`,
      isLoading: !data || data.status === "loading",
      errorMessage: data?.status === "error" ? data.errorMessage : null,
      cards: (data?.items ?? []).map((obra) => ({ key: obra.id, props: obraCardProps(obra) })),
      count: success ? data.total : OBRAS_NO_VALUE,
      total: success ? data.total : undefined,
      isLoadingMore: data?.isLoadingMore ?? false,
      loadMore: () => onLoadMore(column.code),
    };
  });

  return { isLoading, device: isMobile ? "mobile" : "desktop", boardColumns };
}
